/**
 * Quantelys — Google Analytics 4 event tracking
 * 
 * Centralise tous les événements GA custom.
 * Usage : import { trackEvent, trackLogin, ... } from "@/lib/analytics";
 */

// ============== CORE ==============

function gtag() {
  if (window.gtag) {
    window.gtag(...arguments);
  }
}

/** Generic event — use the named helpers below when possible */
export function trackEvent(eventName, params = {}) {
  gtag("event", eventName, params);
}

// ============== AUTH ==============

export function trackLogin(method = "email") {
  trackEvent("login", { method });
}

export function trackLogout() {
  trackEvent("logout");
}

export function trackSignUp(tenantSlug) {
  trackEvent("sign_up", { method: "self_service", tenant_slug: tenantSlug });
}

// ============== USER IDENTITY (for GA audience/segments) ==============

export function setUserProperties(props = {}) {
  gtag("set", "user_properties", props);
}

/** Call after login — sets tenant + role for all subsequent events */
export function identifyUser({ role, tenantSlug }) {
  setUserProperties({
    user_role: role,
    tenant_slug: tenantSlug,
  });
}

// ============== PRODUCTS ==============

export function trackProductSearch(query, resultsCount) {
  trackEvent("search", {
    search_term: query,
    results_count: resultsCount,
  });
}

export function trackProductCreate() {
  trackEvent("product_create");
}

export function trackProductImport(fileType, count) {
  trackEvent("product_import", { file_type: fileType, items_count: count });
}

// ============== EXPORTS ==============

export function trackExport(format, type) {
  trackEvent("file_export", {
    file_format: format,       // "csv", "excel", "pdf"
    export_type: type,         // "products", "by_supplier", "order_pdf", "backup"
  });
}

// ============== ORDERS ==============

export function trackOrderCreate(itemsCount) {
  trackEvent("order_create", { items_count: itemsCount });
}

export function trackOrderEmail(orderId) {
  trackEvent("order_email_sent", { order_id: orderId });
}

export function trackOrderReceive(orderId) {
  trackEvent("order_receive", { order_id: orderId });
}

// ============== MOVEMENTS ==============

export function trackMovementCreate(type) {
  trackEvent("movement_create", { movement_type: type }); // "in" or "out"
}

// ============== INVOICES / FINANCES ==============

export function trackInvoiceCreate() {
  trackEvent("invoice_create");
}

export function trackInstallmentPaid(invoiceId) {
  trackEvent("installment_paid", { invoice_id: invoiceId });
}

// ============== INVENTORY ==============

export function trackInventoryCount(productsCount) {
  trackEvent("inventory_count", { products_count: productsCount });
}

// ============== BILLING ==============

export function trackBillingCheckout() {
  trackEvent("begin_checkout", { currency: "EUR" });
}

export function trackBillingPortal() {
  trackEvent("billing_portal_open");
}

// ============== ADMIN ==============

export function trackBackup() {
  trackEvent("admin_backup");
}

export function trackRestore() {
  trackEvent("admin_restore");
}

// ============== CATEGORIES ==============

export function trackCategoryNormalize() {
  trackEvent("category_normalize");
}

export function trackCategoryMerge() {
  trackEvent("category_merge");
}

// ============== PAGE VIEW (SPA) ==============

export function trackPageView(pagePath, pageTitle) {
  gtag("event", "page_view", {
    page_path: pagePath,
    page_title: pageTitle,
  });
}
